import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6102e316"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "course-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "bottom"
};
const _hoisted_5 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_6 = {
  class: "course-teacher text-overflow"
};
const _hoisted_7 = {
  class: "teacher-photo"
};
const _hoisted_8 = {
  class: "photo-item"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "teacher-info"
};
const _hoisted_11 = {
  class: "name text-overflow"
};
const _hoisted_12 = {
  class: "text-overflow"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "course-mes"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 累计选课 ");

const _hoisted_16 = {
  class: "unit"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 人 ");

const _hoisted_18 = {
  class: "course-mescredit"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 学分 ");

const _hoisted_20 = {
  class: "num"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "course-line"
}, null, -1));

const _hoisted_22 = {
  class: "course-meshour"
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 学时 ");

const _hoisted_24 = {
  class: "num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.courseData.course_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $props.courseData.avatar || require('@/assets/images/user_avatar.jpg'),
    alt: ""
  }, null, 8, _hoisted_9)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($props.courseData.lecturer), 1), _createElementVNode("p", _hoisted_12, [_createTextVNode(_toDisplayString($props.courseData.organ_name) + " ", 1), $props.courseData.organ_name && $props.courseData.post ? (_openBlock(), _createElementBlock("span", _hoisted_13, "-")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($props.courseData.post), 1)])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString($props.courseData.students_num || 0), 1), _hoisted_17]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString($props.courseData.credit || 0), 1)]), _hoisted_21, _createElementVNode("span", _hoisted_22, [_hoisted_23, _createElementVNode("span", _hoisted_24, _toDisplayString($props.courseData.hours || 0), 1)])])])])])]);
}